import _ from 'lodash';

import { updateSecurityGroups } from '../../../../redux/actions/application';
import { Dispatch, GetState } from '../../../../redux/redux.types';
import { getSelectedApplication } from '../../../../selectors/applications/applications';

export const APPLICATION_PERMISSION_ACTION_NAMES = {
  SHOW_INFO_SIDEBAR: 'APPLICATION_PERMISSION_ACTION_NAMES-SHOW_INFO_SIDEBAR',
  HIDE_INFO_SIDEBAR: 'APPLICATION_PERMISSION_ACTION_NAMES-HIDE_INFO_SIDEBAR',
};

export const showInfoSidebar = (permissionId?: string) => ({
  type: APPLICATION_PERMISSION_ACTION_NAMES.SHOW_INFO_SIDEBAR,
  payload: permissionId,
});

export const hideInfoSidebar = () => ({
  type: APPLICATION_PERMISSION_ACTION_NAMES.HIDE_INFO_SIDEBAR,
  payload: undefined,
});

export const addApplicationGroup =
  (applicationGroup: string) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const application = getSelectedApplication(state);

    dispatch(
      updateSecurityGroups([...application.securityGroups, applicationGroup]),
    );
  };

export const deleteApplicationGroup =
  (applicationGroup: string) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const application = getSelectedApplication(state);
    const applicationGroups = [...application.securityGroups];

    _.remove(applicationGroups, (item: string) => applicationGroup === item);

    dispatch(updateSecurityGroups(applicationGroups));
  };
